.sidebar-container {
    width: 250px;
}

.chart-wrapper {
    width: calc(100% - 250px);
}

@media (max-width: 1399px) {
    .sidebar-container {
        display: none;
    }
    .chart-wrapper {
        width: 100%;
    }
}
